/**
 * The order number people read and search for: "#" plus the last six
 * characters of the order id, upper case. It is service-core's rule
 * (`util/OrderNr`), so `ebb56f33-ad4c-41b3-a87c-cd1a176bf4d8` is `#6BF4D8` on
 * every screen, in e-mails and in the list search. When a payload already has
 * `orderNr`, show that; use this when it doesn't.
 *
 * Never throws: a missing or blank id gives '', and an id shorter than six
 * characters is used whole.
 */
export function formatOrderNr(orderId?: string | null): string {
  const id = (orderId ?? '').trim()
  if (!id) return ''
  return `#${id.slice(-6).toUpperCase()}`
}
